export type DeepLinkIntent =
  | { kind: "home" }
  | { kind: "record"; id: string }
  | { kind: "prayerRun"; id: string };

const HTTPS_ORIGIN = "https://aiqs.d-planet.love";
const CUSTOM_SCHEME = "love.dplanet.aiqs:";
const SAFE_ID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function parsePath(pathname: string): DeepLinkIntent | null {
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length === 0 || (parts.length === 1 && parts[0] === "home")) return { kind: "home" };
  if (parts.length !== 2 || !SAFE_ID.test(parts[1] ?? "")) return null;
  if (parts[0] === "records") return { kind: "record", id: parts[1]! };
  if (parts[0] === "prayer-runs") return { kind: "prayerRun", id: parts[1]! };
  return null;
}

export function parseDeepLink(rawUrl: string): DeepLinkIntent | null {
  let url: URL;
  try {
    url = new URL(rawUrl);
  } catch {
    return null;
  }

  if (url.username || url.password || url.search || url.hash) return null;

  if (url.protocol === "https:" && url.origin === HTTPS_ORIGIN) {
    if (url.pathname === "/app" || url.pathname === "/app/") return { kind: "home" };
    if (!url.pathname.startsWith("/app/")) return null;
    return parsePath(url.pathname.slice("/app/".length));
  }

  if (url.protocol === CUSTOM_SCHEME && url.hostname === "open") {
    return parsePath(url.pathname);
  }

  return null;
}
